import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/cpJMf45p4dJ8fZFJQgTHYU/Captura_de_pantalla_2025-12-15_234149.png',
  alt: 'Actividad 19 – Análisis de un texto expositivo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mJ2Bm8h9RcEfUaoyS2vZfS/Captura_de_pantalla_2025-12-15_234300.png',
  alt: 'Actividad 33 – Conectores argumentativos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6UApecdfpAUdpbQLXNjbTA/Captura_de_pantalla_2025-12-15_234410.png',
  alt: 'Actividad 41 – Verdadero o falso: Características de un texto narrativo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a45u9bXahS9nfHXJiEtcvs/Captura_de_pantalla_2025-12-15_234457.png',
  alt: 'Actividad 17 – Completar espacios: Conectores argumentativos'
}];
export function ActividadesCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % IMAGES.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const goTo = (index: number) => {
    setCurrent(index);
  };
  const prev = () => {
    setCurrent(p => (p - 1 + IMAGES.length) % IMAGES.length);
  };
  const next = () => {
    setCurrent(p => (p + 1) % IMAGES.length);
  };
  return <section className="py-8 sm:py-14 bg-[#0f172a]" data-id="element-14">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-15">
        <div className="text-center mb-5 sm:mb-8" data-id="element-16">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-17">
            Estas son algunas de las actividades que encontrarás en el{' '}
            <span className="text-[#fbbf24]" data-id="element-18">
              Kit Completo de Lengua y Literatura
            </span>
          </h2>
        </div>

        <div className="relative" data-id="element-19">
          {/* Carousel Container */}
          <div className="overflow-hidden rounded-xl shadow-2xl border border-gray-700 bg-[#1e293b]" data-id="element-20">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${current * 100}%)`
          }} data-id="element-21">
              {IMAGES.map((img, i) => <div key={i} className="w-full flex-shrink-0" data-id="element-22">
                  <img src={img.src} alt={img.alt} className="w-full h-auto" data-id="element-23" />
                </div>)}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-1.5 sm:p-2 transition-colors backdrop-blur-sm" aria-label="Anterior" data-id="element-24">
            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-25" />
          </button>
          <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-1.5 sm:p-2 transition-colors backdrop-blur-sm" aria-label="Siguiente" data-id="element-26">
            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-27" />
          </button>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-28">
            {IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-[#fbbf24] scale-125' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-29" />)}
          </div>
        </div>
      </div>
    </section>;
}